import { IInitialState } from 'src/store/initialState';

const checkoutSel = (state: IInitialState): IInitialState['checkout'] =>
  state.checkout;
const checkoutCartSel = (
  state: IInitialState
): IInitialState['checkout']['cart'] => checkoutSel(state).cart;

export const checkoutCodeSel = (state: IInitialState) =>
  checkoutSel(state).checkoutCode;
export const checkoutItemsSel = (state: IInitialState) =>
  checkoutCartSel(state).items;
export const checkoutItemCountSel = (state: IInitialState) =>
  checkoutCartSel(state).itemCount;
export const checkoutDeliverMethodSel = (state: IInitialState) =>
  checkoutCartSel(state).delivery;
export const checkoutDeliveryLocationSel = (state: IInitialState) =>
  checkoutCartSel(state).deliveryLocation;
export const checkoutDeliveryLocationCode = (state: IInitialState) =>
  checkoutCartSel(state).deliveryLocationCode;
export const checkoutSubtotalSel = (state: IInitialState) =>
  checkoutSel(state).subtotal;
export const checkoutTax = (state: IInitialState) => checkoutSel(state).tax;
export const checkoutTotal = (state: IInitialState) => checkoutSel(state).total;
export const checkoutDefaultMOT = (state: IInitialState) =>
  checkoutSel(state).defaultMOT;
export const checkoutShippingMethod = (state: IInitialState) =>
  checkoutSel(state).shippingMethod;
export const checkoutTermsOfDelivery = (state: IInitialState) =>
  checkoutSel(state).termsOfDelivery;
export const checkoutSoftCreditHoldSel = (state: IInitialState) =>
  checkoutSel(state).softCreditHold;
export const checkoutIsPendingSel = (state: any) => state.checkout.isPending;
export const checkoutOrderConfirmedSel = (state: any) =>
  state.checkout.orderConfirmed;
export const checkoutCreditCardUrlSel = (state: any) =>
  state.checkout.creditCardUrl;
export const checkoutPendingOrderNumberSel = (state: any) =>
  state.checkout.pendingOrderNumber;
export const checkoutConfirmationNumberSel = (state: any) =>
  state.checkout.confirmationNumber;
export const checkoutErrorSel = (state: any) => state.checkout.error;
export const placeOrderProgressSel = (state: any) =>
  state.checkout.placingOrderProgress;
